import PrivacyPolicyModal from './PrivacyPolicyModal';

export default PrivacyPolicyModal;



// WEBPACK FOOTER //
// ./src/ondemand/components/PrivacyPolicyModal/index.js